import { createApp } from 'vue'
import App from './App.vue'
import HelloWorld from './components/HelloWorld.vue'

// 添加视口调整脚本，提高小屏幕设备可读性
function optimizeViewport() {
  // 获取设备宽度
  const deviceWidth = window.innerWidth;
  
  // 针对超小屏幕设备优化缩放
  if (deviceWidth <= 375) {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=2.0, user-scalable=yes';
    }
  }

  // 设置CSS变量以减少小型设备上的动画效果
  if (deviceWidth <= 480) {
    // 减少动画效果，提高性能
    document.documentElement.style.setProperty('--bubble-opacity', '0.05');
    
    // 低端设备上减少动画过渡时间，提升响应速度
    document.documentElement.style.setProperty('--transition-speed', '0.2s');
  }
}

// 在DOM加载完成后执行优化
document.addEventListener('DOMContentLoaded', optimizeViewport);
// 在窗口大小改变时重新优化视口
window.addEventListener('resize', optimizeViewport);

const app = createApp(App)
app.component('HelloWorld', HelloWorld)
app.mount('#app')
